<template>
  <customModal :containermd="true" @closeModal="$emit('closeModal')">
    <template #title>
      Audit Trail Summary
    </template>

    <template #body>
      <div class="modal-content-wrapper">
        <div class="section-block">
         <h6 class="section-title">
            {{ fromPage === 'ctqsignalreview' ? 'CTQ Factor' : 'Risk Indicator' }}
          </h6>

          <div class="row">

            <!-- LEFT SECTION -->
            <div class="col-md-6">

              <div class="d-flex border-bottom py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>Scope</strong>
                </div>
                <div>
                  {{ resolvedData?.riskIndicator?.scope }}
                </div>
              </div>

              <div class="d-flex border-bottom py-2">
               <div class="me-3" style="min-width: 150px;">
                  <strong>
                    {{ fromPage === 'ctqsignalreview' ? 'CTQ Factor' : 'Risk Indicator' }}
                  </strong>
                </div>
                <div>
                  {{ resolvedData?.riskIndicator?.riskName }}
                </div>
              </div>

              <div class="d-flex border-bottom py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>Version</strong>
                </div>
                <div>
                  {{ resolvedData?.riskIndicator?.version }}
                </div>
              </div>


              <div class="d-flex py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>Execution Type</strong>
                </div>
                <div>
                  {{ resolvedData?.riskIndicator?.executionType }}
                </div>
              </div>

            </div>


            <!-- RIGHT SECTION -->
            <div class="col-md-6">
              <div class="d-flex border-bottom py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>From Date</strong>
                </div>
                <div>
                  {{ formatdatetime(resolvedData?.fromDate) }}
                </div>
              </div>

                <div class="d-flex border-bottom py-2">
                  <div class="me-3" style="min-width: 150px;">
                    <strong>To Date</strong>
                  </div>
                  <div>
                    {{ formatdatetime(resolvedData?.toDate) }}
                  </div>
                </div>




              <div class="d-flex border-bottom py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>Run Date</strong>
                </div>
                <div>
                  {{ formatdatetime(resolvedData?.riskIndicator?.runTimestamp) }}
                </div>
              </div>

               <div class="d-flex border-bottom py-2">
                <div class="me-3" style="min-width: 150px;">
                  <strong>Run By</strong>
                </div>
                <div>
                  {{ resolvedData?.CreatedUserEmail }}
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="section-block mt-4">
         <h6 class="section-title" style="cursor: pointer;" @click="showDataReference = !showDataReference">
            <strong>
              Data Reference
              <i :class="showDataReference ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="ms-2"></i>
            </strong>
          </h6>
          <div v-if="showDataReference">

            <div v-if="resolvedData?.dataReference?.length">
              <div class="table-responsive data-ref-table">
               <table class="table table-striped table-bordered">
                 <thead>
                    <tr>
                      <th rowspan="2">Source</th>
                      <th rowspan="2">Site Code</th>
                      <th rowspan="2">Subject No</th>
                      <th rowspan="2">Visit No</th>
                      <th rowspan="2">Form Name</th>

                      <!-- fieldName/fieldValue: no grouping needed -->
                      <template v-if="hasFieldNames()">
                        <th rowspan="2">Field Name</th>
                        <th rowspan="2">Field Value</th>
                      </template>

                      <!-- scheduleData or queryData -->
                     <template v-else-if="getAllDynamicKeys().length">
                        <th :colspan="getAllDynamicKeys().length" class="text-center group-header">
                          {{ hasScheduleData() ? 'Risk Calculation Reference' : 'Risk Calculation Reference' }}
                        </th>
                      </template>
                    </tr>

                    <tr>
                      <template v-if="!hasFieldNames() && getAllDynamicKeys().length">
                        <th v-for="key in getAllDynamicKeys()" :key="key">
                          {{ formatColumnHeader(key) }}
                        </th>
                      </template>
                    </tr>
                  </thead>

                 <tbody>
                   <tr v-for="(ref, index) in resolvedData.dataReference" :key="index">
                      <td>{{ ref.source }}</td>
                      <td>{{ ref.siteCode }}</td>
                      <td>{{ ref.subjectNo }}</td>
                      <td>{{ ref.visitNo }}</td>
                      <td>{{ ref.formName }}</td>

                      <template v-if="ref.fieldName">
                        <td>{{ ref.fieldName || "-" }}</td>
                        <td>
                          {{
                            Array.isArray(ref.fieldValue)
                              ? ref.fieldValue.join(", ")
                          : (ref.fieldValue || "-")
                          }}
                        </td>
                      </template>

                      <template v-else>
                       <td v-for="key in getAllDynamicKeys()" :key="key">
                          {{ formatCellValue((ref.scheduleData || ref.queryData || {})[key]) }}
                        </td>
                      </template>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else class="text-muted">
              No data reference available
            </div>

          </div>
        </div>


      </div>
    </template>

  </customModal>
</template>
<script src="./ReportViewModal.js"></script>
<style scoped>
.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.label {
  font-weight: 600;
  color: #6c757d;
}

.value {
  font-weight: 500;
  color: #212529;
  text-align: right;
}



.data-ref-table {
  max-height: 300px;
  overflow-y: auto;
}
.group-header {
  background-color: #e9f0fb;
  color: #2c5282;
  font-weight: 600;
  border-bottom: 2px solid #2c5282;
}
</style>
